import React from 'react';
import { formatarMoeda } from '../lib/utils';

type ThemeKey = 'lightgray' | 'darkgray' | 'lightgreen' | 'darkgreen' | 'lightred' | 'darkred'

interface Props {
  children: string;
  onClick?: () => void;
  theme: ThemeKey;
  price?: string;
  selected?: boolean;
}

type ThemeValues = {
  border: string,
  bg: string,
  font_color: string,
  hover: string
}

const DotInvoice: React.FC<Props> = ({ children, theme, onClick, price, selected }) => {
  
  if(selected){
    if(theme === "lightred") theme = "darkred"
    if(theme === "lightgray") theme = "darkgray"
    if(theme === "lightgreen") theme = "darkgreen"
  }

  const theme_model: Record<ThemeKey, ThemeValues> = {
    lightgray: {
      border: "border-gray-primary",
      bg: "bg-gray-light",
      font_color: "text-blue-primary",
      hover: "hover:bg-gray-medium"
    },
    darkgray: {
      border: "border-gray-primary",
      bg: "bg-gray-medium",
      font_color: "text-blue-primary",
      hover: "hover:bg-gray-medium"
    },
    lightgreen: {
      border: "border-green-dark",
      bg: "bg-green-light",
      font_color: "text-green-dark",
      hover: "hover:bg-green-medium"
    },
    darkgreen: {
      border: "border-green-medium",
      bg: "bg-green-medium",
      font_color: "text-white-primary",
      hover: "hover:bg-green-dark"
    },
    lightred: {
      border: "border-red-primary",
      bg: "bg-red-light",
      font_color: "text-red-primary",
      hover: "hover:bg-red-primary hover:text-white-primary"
    },
    darkred: {
      border: "border-red-primary",
      bg: "bg-red-primary",
      font_color: "text-white-primary",
      hover: "hover:bg-red-dark"
    },
  }


  return (
    <button
      className={`
        px-[0.9rem]
        py-[0.75rem]
        rounded-[0.5rem]
        flex flex-col
        justify-center
        items-center
        border
        w-[100%]
        ${theme_model[theme].border}
        ${theme_model[theme].font_color}
        ${theme_model[theme].bg}
        ${theme_model[theme].hover}
     `}
      onClick={onClick}
    >
      <strong>{children}</strong>
      <p className={'mt-[0.62rem]'}>R${formatarMoeda(Number(price))}</p>
    </button >
  );
}

export default DotInvoice;
